'use strict';
const _ = require('underscore');
module.exports = function progressSortConfig(config) {
	const configWithKeys = _.map(config, function (val, idx) {
			return _.extend({key: idx}, val);
		}),
		sortedAlpha = _.sortBy(configWithKeys, function (status) {
			return status.description || status.key;
		});
	return _.sortBy(sortedAlpha, function (status) {
		return -1 * status.priority || 0;
	});
};
